export default __webpack_public_path__ + "media/src/assets/images/IconButtonClose-033a6bd7baf542130e2bcf9588702674.svg";